import { render } from "./RegisterForm.vue?vue&type=template&id=1b4fdf9b&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"

import "./RegisterForm.vue?vue&type=style&index=0&id=1b4fdf9b&lang=css"
import "./RegisterForm.vue?vue&type=style&index=1&id=1b4fdf9b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4fdf9b"]])

export default __exports__